import React, { useState, Children } from "react";
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";
import { RxDotFilled } from "react-icons/rx";

const Slide= (props) => {
    const [url, setUrl] = useState(props.url);
    const [alt, setAlt] = useState(props.alt);
    return(<p>{alt}</p>);
}

    const Carrusel = (props) => {
        const slides = Children.toArray(props.children);
        const [currentIndex, setCurrentIndex] = useState(0);
    
    const prevSlide = () => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };

    const nextSlide = () => {
        const isLastSlide = currentIndex === slides.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    };

    const goToSlide = (slideIndex) => {
        setCurrentIndex(slideIndex);
    };

    return (
        <section role="contentinfo" aria-label="Carrusel">
        <div className="w-full m-auto py-8 flex flex-col items-center" style={{ lineHeight: '2rem', textAlign: 'center' }}>
            <div className="flex items-center justify-center">
                {/* FLECHA IZQ */}
                <div className='text-2xl rounded-full p-2 m-2 bg-black/20 text-white cursor-pointer' aria-label="Anterior" role="button" aria-hidden="false">
                    <BsChevronCompactLeft onClick={prevSlide} size={30} />
                </div>

                {/* IMAGEN */}
                <img
                    src={slides[currentIndex].props.src}
                    alt={slides[currentIndex].props.alt}
                    style={{
                        width: '45%', 
                        height: '50%', 
                        objectFit: 'cover', 
                        borderRadius: '10px', 
                        display: 'inline-block',
                    }}
                    className="rounded-2xl bg-center bg-cover duration-500 mx-center"
                />

                {/* FLECHA DERECHA */}
                <div className="text-2xl rounded-full p-2 m-2 bg-black/20 text-white cursor-pointer" aria-label="Siguiente" role="button" aria-hidden="false">
                    <BsChevronCompactRight onClick={nextSlide} size={30} />
                </div>
            </div>

            {/* PUNTOS */}
            <div className="flex mt-2">
                {slides.map((slide, slideIndex) => (
                    <div
                        key={slideIndex}
                        onClick={() => goToSlide(slideIndex)}
                        className={slideIndex === currentIndex ? 'text-2xl cursor-pointer text-teal-500' : 'text-2xl cursor-pointer text-white'}
                        aria-label={(slideIndex+1)+": "+slide.props.alt}
                        role="button"
                        aria-pressed={slideIndex === currentIndex}
                    >
                        <RxDotFilled />
                    </div>
                ))}
            </div>
        </div>
    </section>
    );
};

export default Carrusel;